export default "__VITE_ASSET__bc317e89__"